import { render, staticRenderFns } from "./statisticsData.vue?vue&type=template&id=0a1d281a&scoped=true"
import script from "./statisticsData.vue?vue&type=script&lang=js"
export * from "./statisticsData.vue?vue&type=script&lang=js"
import style0 from "./statisticsData.vue?vue&type=style&index=0&id=0a1d281a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1d281a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a1d281a')) {
      api.createRecord('0a1d281a', component.options)
    } else {
      api.reload('0a1d281a', component.options)
    }
    module.hot.accept("./statisticsData.vue?vue&type=template&id=0a1d281a&scoped=true", function () {
      api.rerender('0a1d281a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/components/statisticsData.vue"
export default component.exports